import { AnimatePresence, motion } from 'motion/react';
import '../styles/NavMenu.css';

const LINKS = [
  { label: 'HOME', href: '#home', active: true },
  { label: 'THE COMEBACK', href: '#the-comeback' },
  { label: 'HOW IT WORKS', href: '#how-it-works' },
  { label: 'THE STEPS', href: '#the-steps' },
  { label: 'FAQS', href: '#faqs' },
];

/**
 * Full-screen (mobile) / right-panel (desktop) nav overlay.
 * The dark backdrop dims + grays out the page behind it (matches the
 * screenshot: hero text goes gray while the menu is open), the panel
 * itself slides in from the right.
 */
export default function NavMenu({ isOpen, onClose }) {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            className="nav-menu__backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            onClick={onClose}
          />
          <motion.aside
            className="nav-menu"
            role="dialog"
            aria-modal="true"
            aria-label="Site menu"
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          >
            <div className="nav-menu__header">
              <span className="nav-menu__title">MENU</span>
              <button
                type="button"
                className="nav-menu__close"
                aria-label="Close menu"
                onClick={onClose}
              >
                ×
              </button>
            </div>

            <nav className="nav-menu__list">
              {LINKS.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className={`nav-menu__link ${link.active ? 'is-active' : ''}`}
                  onClick={onClose}
                >
                  <span>{link.label}</span>
                  {link.active && <span className="nav-menu__dot" />}
                </a>
              ))}
            </nav>
          </motion.aside>
        </>
      )}
    </AnimatePresence>
  );
}